import Vue from 'vue'
import Brand from './brand.vue'
import '@/common/config.js'
import utils from '@/common/js/utils.js'
import { Icon } from 'element-ui';
// 引入公共CSS文件
import '@/common/app.css';
import 'swiper/css/swiper.min.css';

Vue.prototype.$util = utils;
Vue.use(Icon);

new Vue({
    render: h => h(Brand),
}).$mount('#app')